import React from 'react';
import PropTypes from 'prop-types';
import Dialog from './Dialog';
import Text from './Text';
import Button from './Button';
import Container from './Container';

const AlertDialog = ({ heading, text, buttons, ...props }) => (
  <Dialog maxWidth="335px" padding="15px" {...props}>
    {heading && (
      <Text
        display="block"
        fontSize="18px"
        color="normal"
        fontWeight="600"
        lineHeight="1.2"
        marginBottom="13px"
      >
        {heading}
      </Text>
    )}
    {text && (
      <Text display="block" fontSize="16px" color="text400" lineHeight="1.2">
        {text}
      </Text>
    )}
    {!!buttons.length && (
      <Container display="flex" marginTop="18px">
        {buttons.map(button => (
          <Button
            key={button.children}
            fontSize="16px"
            height="44px"
            {...button.props}
          >
            {button.children}
          </Button>
        ))}
      </Container>
    )}
  </Dialog>
);

AlertDialog.propTypes = {
  heading: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  buttons: PropTypes.arrayOf(PropTypes.shape({})),
};

AlertDialog.defaultProps = {
  heading: null,
  text: null,
  buttons: [],
};

export default AlertDialog;
